import { Download } from "lucide-react";
import "../styles/views/library-view.css";
import TrackList from "../components/lists/TrackList";

function LibraryView({ playlists, relatedTracks }) {
  return (
    <>
      <section>
        <h3 className="section-title">Your Playlists</h3>
        <div className="card-grid">
          {playlists.map((playlist) => (
            <article className="playlist-card glass-panel" key={playlist.id}>
              <img src={playlist.cover} alt={playlist.title} />
              <h4>{playlist.title}</h4>
              <p>{playlist.songs} songs</p>
            </article>
          ))}
        </div>
      </section>

      <section className="glass-panel panel-block">
        <div className="section-inline">
          <h3 className="section-title">Downloaded Tracks</h3>
          <button type="button" className="ghost-btn">
            <Download size={14} />
            Manage Downloads
          </button>
        </div>
        <TrackList tracks={relatedTracks} showPlays />
      </section>
    </>
  );
}

export default LibraryView;
